exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-card-login .md-card-header[data-v-5ebaec66] {\r\n    background-color: transparent;\r\n    margin: 0;\r\n    text-align: left;\n}\r\n", ""]);

// exports
